import { useMutation } from '@apollo/client';
import { useCallback, useState } from 'react';

import { UPDATE_INTERNAL_GROUP_PERMISSION, UpdateInternalGroupPermissionType } from '../../../api/permission';
import { GroupPermissionType } from '../../../types/permission';
import SettingsItemPermission from '../../SettingsItemPermission';

type InternalGroupPermissionProps = {
	permission: GroupPermissionType;
	disabled: boolean;
	onPermissionChanged: (value: boolean) => void;
};

const InternalGroupPermission = ({
	permission: { id, name, value: initialValue },
	disabled,
	onPermissionChanged,
}: InternalGroupPermissionProps) => {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	const [value, setValue] = useState(initialValue);

	const [updatePermission, { loading }] = useMutation<UpdateInternalGroupPermissionType>(
		UPDATE_INTERNAL_GROUP_PERMISSION,
		{
			onCompleted: (data) => {
				const { updateInternalGroupPermission } = data ?? {};
				// eslint-disable-next-line @typescript-eslint/naming-convention
				const { value: updatedValue } = updateInternalGroupPermission ?? {};

				onPermissionChanged(true);
				setValue(updatedValue);
			},
		},
	);

	const handlePermissionUpdate = useCallback(
		(newValue?: boolean | null) => {
			if (value === newValue) return;

			updatePermission({
				variables: {
					updateInternalGroupPermissionInput: { id, value: newValue },
				},
			}).catch((e) => {
				throw e;
			});
		},
		[value, updatePermission, id],
	);

	return (
		<SettingsItemPermission
			label={name}
			loading={loading}
			onChange={handlePermissionUpdate}
			disabled={disabled}
			value={value}
		/>
	);
};

export default InternalGroupPermission;
